import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatBRL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Copy, MessageCircle, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data));
  }, [orderId]);

  if (!order) return <div className="max-w-4xl mx-auto px-4 py-20 text-center">Carregando...</div>;

  const copy = (text) => { navigator.clipboard.writeText(text); toast.success("Copiado!"); };

  return (
    <div className="max-w-3xl mx-auto px-4 py-6 sm:py-10">
      <div className="text-center space-y-3">
        <CheckCircle2 className="h-16 w-16 mx-auto text-green-600" />
        <h1 className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Pedido confirmado!</h1>
        <p className="text-neutral-600">Nº do pedido: <strong data-testid="order-number">{order.order_number}</strong></p>
      </div>

      {order.payment_method === "pix" && order.payment_info?.qr_code && (
        <div className="bg-white border rounded-xl p-6 mt-8 space-y-4">
          <h2 className="font-bold">Pagamento via Pix</h2>
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(order.payment_info.copy_paste)}&size=200x200`} alt="QR Code" className="border rounded" />
            <div className="flex-1 space-y-2">
              <p className="text-sm">Escaneie o QR Code ou copie a linha digitável abaixo:</p>
              <div className="bg-neutral-100 rounded p-2 text-xs break-all font-mono">{order.payment_info.copy_paste}</div>
              <Button variant="outline" onClick={() => copy(order.payment_info.copy_paste)}><Copy className="h-4 w-4 mr-2" />Copiar Pix</Button>
            </div>
          </div>
          <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">
            Modo DEMONSTRAÇÃO (MOCK). Nenhum pagamento real é processado.
          </p>
        </div>
      )}

      <div className="bg-white border rounded-xl p-6 mt-6 space-y-3">
        <h2 className="font-bold">Retirada na loja</h2>
        <div className="flex items-center gap-2 text-sm"><MapPin className="h-4 w-4 text-[#C91F1F]" />{order.pickup_location}</div>
        <p className="text-xs text-neutral-500">Aguarde a confirmação de que seu pedido está pronto antes da retirada.</p>
      </div>

      <div className="bg-white border rounded-xl p-6 mt-6 space-y-3">
        <h2 className="font-bold">Resumo</h2>
        {order.items.map((i, idx) => (
          <div key={idx} className="flex gap-3 text-sm">
            <img src={i.image} className="w-14 h-16 rounded object-cover" alt="" />
            <div className="flex-1"><p className="font-medium">{i.name}</p><p className="text-xs text-neutral-500">Qtd {i.quantity} • {[i.size, i.color].filter(Boolean).join(" • ")}</p></div>
            <span className="font-semibold">{formatBRL(i.line_total)}</span>
          </div>
        ))}
        <div className="border-t pt-3 space-y-1 text-sm">
          <div className="flex justify-between"><span>Subtotal</span><span>{formatBRL(order.subtotal)}</span></div>
          {order.discount > 0 && <div className="flex justify-between text-green-700"><span>Desconto</span><span>-{formatBRL(order.discount)}</span></div>}
          <div className="flex justify-between text-lg font-bold"><span>Total</span><span className="text-[#C91F1F]">{formatBRL(order.total)}</span></div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <a href="https://wa.me/5521984953716" target="_blank" rel="noreferrer" className="flex-1"><Button className="w-full bg-[#25D366] hover:bg-[#1ea952]"><MessageCircle className="h-4 w-4 mr-2" />Falar no WhatsApp</Button></a>
        <Link to="/" className="flex-1"><Button variant="outline" className="w-full">Continuar comprando</Button></Link>
      </div>
    </div>
  );
}
